export default "__VITE_ASSET__2tFkYq36__"